import Cookie from 'js-cookie'
import config from '../../static/config'
import {forEach, getFormatDate, hashOneOf, objEqual, sortOrder, uniqueArray,hasOneOf} from "@/libs/tools";
import axios from "@/libs/api.request";

const {title,cookieExpires,useI18n} = config

export const TOKEN_KEY = 'token'
export const BASE64_TOKEN_KEY = 'base64Token'

export const setToken = (token) => {
  // Cookie.set(TOKEN_KEY, token, {expires: cookieExpires || 1})
  //localStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(TOKEN_KEY, token)
}

export const setBase64Token = (token)=>{
  // Cookie.set(BASE64_TOKEN_KEY,token,{expires: cookieExpires || 1})
  //localStorage.setItem(BASE64_TOKEN_KEY, token);
  sessionStorage.setItem(BASE64_TOKEN_KEY, token)
}

export const clearBase64Token = () => {
  // Cookie.set(BASE64_TOKEN_KEY,null)
  //localStorage.setItem(BASE64_TOKEN_KEY, null);
  sessionStorage.setItem(BASE64_TOKEN_KEY, null)
}

export const getBase64Token = () => {
  // const token = Cookie.get(BASE64_TOKEN_KEY)
  //const token = localStorage.getItem(BASE64_TOKEN_KEY)
  const token = sessionStorage.getItem(BASE64_TOKEN_KEY)
  if (token) return token
  else return false
}

export const clearToken = ()=>{
  // Cookie.set(TOKEN_KEY,null)
  //localStorage.setItem(TOKEN_KEY, null);
  sessionStorage.setItem(TOKEN_KEY, null)
}

export const getToken = () => {
  // const token = Cookie.get(TOKEN_KEY)
  //const token = localStorage.getItem(TOKEN_KEY)
  const token = sessionStorage.getItem(TOKEN_KEY)
  if(token) return token
  else return false
}
export const dateToString = (val) => {
  var date = new Date(val)
  var y = date.getFullYear()
  var m = date.getMonth() + 1
  m = m < 10 ? ('0' + m) : m
  var d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  const time = y + '-' + m + '-' + d
  return time;
}
/*获取发送消息格式数据*/
export const getMsg = (username,password,left,right,sys_user_id,control,method,exten,pstn,msg)=>{
  let message = ''
  if (typeof msg === "undefined" || msg === '' || msg === null){
    message = "{'host':'"+config.server_ip+"','method':'"+method+"','username':'"+username+"','password':'"+password+"','exten':'"+exten+"','pstnnumber':'"+pstn+"','caller':'"+left+"','callee':'"+right+"','sys_user_id':'"+sys_user_id+"','phonesel':'"+control+"'}"
  }else{
    message = "{'host':'"+config.server_ip+"','method':'"+method+"','username':'"+username+"','password':'"+password+"','exten':'"+exten+"','pstnnumber':'"+pstn+"','caller':'"+left+"','callee':'"+right+"','sys_user_id':'"+sys_user_id+"','phonesel':'"+control+"',"+msg+"}"
  }
  return message
}

/*设置分机状态及格式化数据*/
export const produceExten=(extens,status)=>{
  if (!extens || !Array.isArray(status)) {
    return
  }
  if (!extens || status.length <= 0) {
    return []
  }
  let outLine = [].concat(status)
  forEach(status,i=>{
    let item = extens[i.number]
    if(item){
      if (item.exten && item.exten.indexOf('@') > -1) {
        item.out = '0'
      }else{
        item.out = '1'
        item.status = 'UnKnow'
      }
      item.status = i.status
      item.network = i.network
      outLine.splice(outLine.indexOf(i),1)
      switch (item.status) {
        case 'Talking':
          item.order = '-3'
          break
        case 'Broading':
          item.order = '-2.5'
          break
        case 'Ringing':
          item.order = '-2'
          break
        case 'Idle':
          item.order = '-1'
          break
        case 'UnKnow':
          item.order = '1'
          break
        case 'OffLine':
          item.order = '0'
          break
      }
    }
  })
  return extens
}

export const produceLoginExten=(extens)=>{
  if (!Array.isArray(extens) || extens.length <= 0) {
    return []
  }
  let arr = []
  let outLine = []
  let access = []
  let deptAlarm = [];
  let extCount = 0;
  forEach(extens,(item,index)=>{
    if (item.exten.indexOf('@') > -1) {
      item.out = '0'
      extCount++;
    }else{
      item.out = '1'
      item.status = 'UnKnow'
    }
    //优先级 talking > ringing > idle > unknow(外线未知) > order(系统后台排序)
    if(item.status === 'Talking'){
      item.order_list = '-3'
    }else if (item.status === 'Broading'){
      item.order_list = '-2.5'
    }else if (item.status === 'Ringing'){
      item.order_list = '-2'
    }else if (item.status === 'Idle'){
      item.order_list = '-1'
    }else if(item.status === 'UnKnow'){
      item.order_list = '1'
    }else if (item.status === 'OffLine') {
      item.order_list = '0'
    }
    let ext = {};//{exten:12,status:offline,out:0,deptid:1,deptname:c,cameraflag:0,employeename:12,employeeid:1,position:xxx,order:1}
    ext.exten = item.exten.split('@')[0]
    ext.status = item.status
    ext.network = item.netWork
    ext.mac = item.mac
    ext.out = item.out
    ext.deptid = item.dept_id
    ext.deptname = item.deptname
    ext.cameraflag = item.cameraFlag
    ext.linkageVideo = item.linkageVideo
    ext.employeename = item.employeename
    ext.employeeid = item.employee_id
    ext.position = item.position
    ext.order = item.order_list
    ext.model_name = item.model_name
    ext.supportOffline = item.supportOffline
    ext.supportEcho = item.supportEcho
    ext.type_id = item.type_id
    ext.type_name = item.type_name
    ext.volume = item.volume
    ext.alarm = item.alarm
    ext.order_index=index
    ext.show = item.showControl==1?true:false
    if(item.alarm == '1' && item.dept_id){
      deptAlarm.push(item.dept_id)
    }
    arr.push(ext)
    if (item.out === '1') {
      outLine.push(item)
    }
    if (ext.show){
      access.push(ext)
    }
  })
  arr.sort(sortOrder)
  return {extens:arr,outLine:outLine,access:access,deptAlarmList:deptAlarm,extCount:extCount}
}

export const getDataByDeptId=(extens,deptId)=>{
  if (!Array.isArray(extens)) return
  if (extens.length <= 0) {
    return []
  }
  if(deptId === '-1') {return extens;}
  let arr = []
  forEach(extens,item=>{
    if (item.deptid === deptId){
      arr.push(item)
    }
  })
  return arr
}
/**
 *
 * @param extens 全部分机
 * @param deptIdList 用户权限下的分区列表
 *
 * */
export const getDataByDeptIdWithChildren=(extens,deptIdList)=>{
  if (!Array.isArray(extens)) return
  if (extens.length <= 0) {
    return []
  }
  // if(deptId === '-1') {return extens;}
  let arr = []
  forEach(extens,item=>{
    if (  isInArray(deptIdList,item.deptid)){
      arr.push(item)
    }
  })
  return arr
}

export const getDept = (depts,deptId) => {
  if (!Array.isArray(depts)) return
  if (depts.length <= 0) {
    return null
  }
  let dept = null
  forEach(depts,item=>{
    if (item.deptid === deptId+"") {
      dept = item
    }
  })
  if (dept) {
    return dept.deptname
  }
  return '';
}

/*生成呼叫信息*/
export const generInfo=(data)=>{
  if (!data) return
  let callee = data.ExtenInfo.split('@')[0]
  let caller = data.displayNum
  if(callee === caller)return
  if (caller==='null'||callee==='null'||caller===null||callee===null) return
  let type = data.method
  //if(callee === caller)return
  let date = getFormatDate("HH:MM:SS", new Date())
  let json = {"callee":callee,'caller':caller,'type':type,'date':date}
  return json
}

/*生成队列信息*/
export const generQueueInfo=(data)=>{
  if (!data) return
  let queue_name = data.queuename
  let exten = data.displayNum
  let type = data.method
  let date = getFormatDate('HH:MM:SS', new Date())
  let id = data.hasOwnProperty('queueid') ? data.queueid :''
  let json = {'exten':exten,'queue_name':queue_name,'type':type, 'date': date,'queue_id':id}
  return json
}

export const sortVIP = (obj1,obj2)=>{
  return obj2.vip - obj1.vip
}

export const addQueueArr = (arr, info) => {
  let date = getFormatDate("HH:MM:SS", new Date())
  let res = arr
  let queueInfo = {}
  queueInfo.isVip = Number(info.vip_level)
  queueInfo.time = date
  queueInfo.queueName = info.queuename
  queueInfo.queueId = info.queueid
  if (queueInfo.vip !== 0) {
    info.displayNum = '(VIP) '+info.displayNum
  }
  queueInfo.displayNum = info.displayNum;
  queueInfo.exten = info.ExtenInfo
  queueInfo.isSOS = info.isSOS

  let add = true
  if (res.length > 0) {
    for (let i = 0; i < res.length; i++) {
      let oq = res[i]
      if (oq.exten === info.ExtenInfo) {
        add = false
        break
      }
    }
  }
  if (add) {
    if(info.isSOS === "1"){
      res.unshift(queueInfo)
    }else{
      res.push(queueInfo)
    }
  }
  return res.sort(sortVIP)
}

export const updateQueue = (arr, callerNo, calledNo) => {
  if (Array.isArray(arr) && arr.length > 0) {
    for (let i = 0; i < arr.length; i++) {
      if (callerNo == arr[i].exten) {
        arr[i].called = calledNo
        return
      }
    }
  }
}

export const deviceQueueArr = (arr, queueExtens, info) => {
  if (!Array.isArray(queueExtens) || queueExtens.length<=0) return arr
  if (Array.isArray(arr) && arr.length > 0) {
    //去除已出队列的
    let index = -1
    let dis = info.displayNum
    let ex = info.ExtenInfo
    if (ex.indexOf('@') > -1) {
      ex = ex.split('@')[0]
    }
    for (let i = 0; i < queueExtens.length; i++) {
      if (ex === queueExtens[i]){
        index = i
        break
      }
    }
    if (index === -1){
      return arr
    }

    let k = -1
    for (let i = 0; i < arr.length; i++) {
      if (dis === arr[i].exten) {
        k = i
        break
      }
    }
    if (k > -1) {
      arr.splice(k, 1)
    }
  }
  return arr
}

export const deviceQueueArrNoExtens = (arr,info)=>{
  if (Array.isArray(arr) && arr.length > 0) {
    //去除已出队列的
    let index = -1
    let ex = info.ExtenInfo
    if (ex.indexOf('@') > -1) {
      ex = ex.split('@')[0]
    }
    let k = -1
    for (let i = 0; i < arr.length; i++) {
      if (ex === arr[i].exten) {
        k = i
        break
      }
    }
    if (k > -1) {
      arr.splice(k, 1)
    }
  }
  return arr
}

/*更改分机报警状态*/
export const changeExtenAlarm=(extens,exten,type)=>{
  if(!extens)return extens
  let deptId = "";
  const newExtens = JSON.parse(JSON.stringify(extens));
  let item = newExtens[exten]
  if(item.exten === exten){
    switch (type) {
      case '1':
        item.alarm = '1'
        break
      case '0':
        item.alarm = '0'
        break
      default:
        break;
    }
    deptId = item.deptid;
  }
  let param = {
    extens:newExtens,
    deptId:deptId
  }
  return param
}

export const changeExtenStatusForMap = (extens, exten, status, network) => {
  if (!extens) return extens
  if(extens[exten]){
    let item = extens[exten]
    if (item.status === 'Talking' && status === 'Ringing') {
      return extens
    }
    item.status = status
    if (network) {
      item.network = network
    }
    switch (status) {
      case 'Talking':
        item.order = '-3'
        break
      case 'Broading':
        item.order = '-2.5'
        break
      case 'Ringing':
        item.order = '-2'
        break
      case 'Idle':
        item.order = '-1'
        break
      case 'UnKnow':
        item.order = '1'
        break
      case 'OffLine':
        item.order = '0'
        break
    }
  }
  return extens
}

/*更改分机状态*/
export const changeExtenStatus = (extens, exten, status, network) => {
    if (!Array.isArray(extens)) return extens
    if (extens.length <= 0) return extens
    let length = extens.length
    for (let i = 0; i < length; i++) {
        let item = extens[i]
        if (item.exten === exten) {
            if (item.status === 'Talking' && status === 'Ringing') {
                return extens
            }
            item.status = status
            if (network) {
                item.network = network
            }
            switch (status) {
                case 'Talking':
                    item.order = '-3'
                    break
                case 'Broading':
                    item.order = '-2.5'
                    break
                case 'Ringing':
                    item.order = '-2'
                    break
                case 'Idle':
                    item.order = '-1'
                    break
                case 'UnKnow':
                    item.order = '1'
                    break
                case 'OffLine':
                    item.order = '0'
                    break
            }
            break
    }
  }
  extens.sort(sortOrder)
  return extens
}

export const queryShowExtenInfo=(extens,exten)=>{
  if (!Array.isArray(extens) || extens.length <= 0) {
    return null
  }
  let length = extens.length
  if (Array.isArray(extens)) {
    for (let i = 0; i < length; i++) {
      let ext = extens[i]
      if (ext.exten === exten) {
        return ext
      }
    }
    return null
  }
  return null
}
/*获取某个分机数据*/
export const getExten=(extens,exten)=>{
  if (!Array.isArray(extens)) return
  if(extens.length <= 0)return
  let ext = ''
  forEach(extens,item=>{
    if (item.exten === exten){
      ext = item
    }
  })
  return ext
}

export const getStatusExten = (extens,exten)=>{
  if (!Array.isArray(extens) || extens.length <1) return
  for (let i = 0; i < extens.length; i++) {
    let ele = extens[i]
    if (ele.number === exten) {
      return ele
    }
  }
  return
}

export const getStatusByExten = (extens,exten)=>{
  if (!Array.isArray(extens) || extens.length <1) return
  for (let i = 0; i < extens.length; i++) {
    let ele = extens[i]
    if (ele.exten === exten) {
      return ele
    }
  }
  return
}

/*生成区域*/
export const generArea=(extens,deptList)=>{
  if (!Array.isArray(extens)) return
  if(extens.length<=0)return  []
  let arr = []
  let area = {'deptid':'-1','deptname':'全部分区','inline':0,'offline':0,'all':extens.length,'order':0}
  arr.push(area)//{deptid:1,deptname:A,inline:12,offline:10,all:22}
  let _inline = 0
  let _offline = 0
  let _arr = uniqueArray(extens,'deptid')
  //2步可以合并
  //获取分区
  forEach(_arr,item=>{
    let deptid = item.deptid
    let deptname = item.deptname
    let area = {'deptid':deptid,'deptname':deptname,'inline':0,'offline':0,'all':0};
    forEach(deptList,it=>{
      if (area.deptname === it.deptName){
        area.order = it.orderNum
      }
    })
    arr.push(area)
  })
  forEach(extens,item=>{
    let deptid = item.deptid
    let status = item.status
    forEach(arr,it=>{
      let _deptid = it.deptid
      if (deptid === _deptid){
        if (status === 'OffLine'){
          it.offline += 1
        }else{
          it.inline += 1
        }
        it.all += 1
      }
    })
    if (status === 'OffLine'){
      _offline += 1
    }else{
      _inline += 1
    }
  })
  //更新全部分区
  forEach(arr,item=>{
    if (item.deptid === '-1'){
      item.inline = _inline
      item.offline = _offline
    }
  })
  arr.sort(sortOrder)
  return arr
}


/*按钮权限*/
export const hasRole =(roleMenu)=>{
  if (!roleMenu) {
    return false
  }
  let role = localRead('role')
  if (role.indexOf(roleMenu)>-1) return true
  else return false
}

/*菜单权限*/
export const hasMenu = (menu)=>{
  //"lic":"yes;yes;yes;2;yes;yes;yes"[视频联动模块]yes;[报警及预案模块]yes;[电子地图]yes;[控制台数量]2;[ws_sdk控制]yes;[广播及喊话]yes;[内置TTS]yes;[调度客户端会议]yes
  let menuarr = localRead('menu').split(';')
  if(menu <= menuarr.length){
    if (menuarr[menu] === 'yes') {
      return true;
    } else {
      return false;
    }
  }
  return false
}

/*广播优先级*/
export const broadPriority = (num) => {
  switch (num) {
    case '1':
      return 'one_level'
    case '2':
      return 'two_level'
    case '4':
      return 'three_level'
    case '5':
      return 'four_level'
    default:
      return ''
  }
}
/*广播状态*/
export const broadStatus = (status) => {
  switch (status) {
    case '0':
      return 'nostart_status'
    case '1':
      return 'start_status'
    case '2':
      return 'play_status'
    case '3':
      return 'end_status'
    case '4':
      return 'pause_status'
    case '5':
      return 'part_fail'

    default:
      return ''
  }
}

/*离线广播状态(无暂停状态)*/
export const offlineBroadStatus = (status) => {
  if (status == '0' || status == '1' || status == '2') {
    return 'sending'
  }
  if (status == '3') {
    return 'send_complete'
  }
  if (status == '5' ) {
    return 'part_fail'
  }
}


/*广播播放类型*/
export const broadType=(num)=>{
  switch (num) {
    case '0':
      return 'model_one'
    case '1':
      return 'model_two'
    case '2':
      return 'model_three'
    default:
      return ''
  }
}

/*广播播放类型 无后缀*/
export const broadTypeNotSuffix=(num)=>{
  switch (num) {
    case '0':
      return 'model_one_not_suffix'
    case '1':
      return 'model_two_not_suffix'
    case '2':
      return 'model_three_not_suffix'
    default:
      return ''
  }
}
/*广播类型*/
export const broadTask=(num)=>{
  switch (num+'') {
    case '1':
      return 'word_broad'
    case '2':
      return 'music_broad'
    case '3'://file_broad 合并
      return 'word_broad'
    case '4':
      return 'pro_broad'
    case '5':
      return 'see_broad'
    default:
      return ''
  }
}
/*广播类型 不带后缀*/
export const broadTaskNotSuffix=(num)=>{
  switch (num) {
    case '1':
      return 'word_broad_not_suffix'
    case '2':
      return 'music_broad_not_suffix'
    case '3':
      return 'word_broad_not_suffix'
    case '4':
      return 'pro_broad_not_suffix'
    case '5':
      return 'see_broad_not_suffix'
    case '6':
      return 'offline_broad_not_suffix'
    default:
      return ''
  }
}
/*广播播放类型*/
export const broadPlayType=(num)=>{
  switch (num) {
    case '1':
      return 'order_model'
    case '2':
      return 'random_model'
    case '3':
      return 'cir_model'
    default:
      return ''
  }
}
/*广播周时间标签数组*/
export const broadWeekTime=(data)=>{
  if (!data)return
  let str = []
  let dayOfWeek = new Array('week_one','week_two','week_three','week_four','week_five','week_six','week_seven')
  forEach(data,item=>{
    str.push(dayOfWeek[Number(item.week_day)])
  })
  return Array.from(new Set([...str]))
}

/*自检任务循环时间*/
export const selfCheckCycle=(data)=>{
  if (!data)return
  let str = []
  let dayOfWeek = new Array('week_one','week_two','week_three','week_four','week_five','week_six','week_seven')
  forEach(data,item=>{
    str.push(dayOfWeek[Number(item)])
  })
  return Array.from(new Set([...str]))
}

/*自检播放类型*/
export const selfTimeType=(num)=>{
  switch (num) {
    case '1':
      return 'self_fixed_time'
    case '2':
      return 'self_cycle_time'
    default:
      return ''
  }
}

/*读取txt文件*/
export const readerTxt=(file)=>{
  if (!file) return
  return new Promise((resolve, reject) => {
    let value = ''
    let reader = new FileReader()
    reader.onload = ()=>{
      if (reader.result) {
        resolve(reader.result)
      }else{
        reject()
      }
    }
    reader.readAsText(file,'gbk')
  })
}

export const transferFromDataExten=(_extens,groups,extens)=>{
  //过滤出已选的分机
  let arr = []
  let _exten = [].concat(extens)
  let k = 0
  for(let i = 0; i < _exten.length; i++){
    for (let j = 0; j < _extens.length; j++) {
      if (extens[i].exten === _extens[j]) {
        arr.push(i)
      }
    }
  }
  for (let t = 0; t < arr.length; t++) {
    _exten.splice(arr[t] - k ,1)
    k++
  }
  return transferExtenData(groups,_exten,'from')
}
export const transferToDataExten=(_extens,groups,extens)=>{
  let arr = []
  forEach(extens,item=>{
    forEach(_extens,it=>{
      if (item.exten === it){
        arr.push(item)
      }
    })
  })
  return transferExtenData(groups,arr,'to')
}
export const transferExtenData=(groups,extens,type)=>{
  if (!groups || !extens) return
  let data = []
  forEach(groups,item=>{
    let group = {}
    let children = []
    group.id = item.deptid
    group.pid = 0
    group.label = item.deptname
    forEach(extens,it=>{
      if (it.deptname === item.deptname){
        //外线的排除
        if (it.out === '0') {
          let ext = {}
          ext.id = it.exten
          ext.label = it.exten
          ext.children = []
          ext.pid = item.deptid
          children.push(ext)
        }
      }
    })
    group.children=children
    if (type==='from'){
      //第一级无论有没有子节点都添加
      if (item.deptid !== '-1'){
        data.push(group)
      }
    }else if(type === 'to'){
      //第一级无子节点不添加
      if (item.deptid !== '-1' && group.children.length > 0){
        data.push(group)
      }
    }

  })
  return data
}

/*返回叶子节点数组对象*/
export const transferDataToArray = (array=[],returnArray=[])=>{
  if (!array)return
  for (let i = 0; i < array.length; i++) {
    if("0" == array[i].isDept && !array[i].isLinkMan){
      returnArray.push(array[i])
    }
    if("0" == array[i].isDept && '1' == array[i].isLinkMan){
      returnArray.push(array[i])
    }
    if((!array[i].children || array[i].children.length == 0) && array[i].userId && array[i].userName){
      returnArray.push(array[i])
    }
    if (array[i].children) {
      returnArray = transferDataToArray(array[i].children, returnArray)
    }
  }
  return returnArray
}

/*生成邀请未选树数组*/
export const transferAll = (array,hasArray) => {
  if (!Array.isArray(array)) return
  //根节点
  let arr = []
  let sys = {id:'1',pId:'1',label:'sys',children:[]}
  let address = {id: '2', pId: '2', label: 'address_book', children: []}
  let group = [] //所有的分组
  let k = 3
  //会发生同名的问题
  forEach(array,item=>{
    let f = group.some(it=>{
      if (it.pId === item.type) {
        return it.label === item.dept_name;
      } else {
        return false
      }
      //return it.label === item.dept_name;
    })
    if(!f){
      let json = {label: item.dept_name,pId: item.type,children:[],id:k+''}
      group.push(json)
      if (json.pId === '1'){
        sys.children.push(json)
      }else{
        address.children.push(json)
      }
      k++
    }
  })
  forEach(array,item=>{
    let f = hasArray.some(val=>{
      return val === item.exten
    })
    if(f){
      item.disabled = true
    }
    item.label = item.exten + ','+ item.employee_name
    item.id = item.exten
    item.children = []
    forEach(group,it=>{
      if (it.pId === item.type) {
        if(item.dept_name === it.label){
          item.pId = it.id;
          it.children.push(item);
        }
      }
    })

  })
  arr.push(sys)
  arr.push(address)
  return arr
}
/*notice function*/
export const noticeType = (type) => {
  switch (type) {
    case '0':
      return 'one_type'
    case '1':
      return 'two_type'
    case '2':
      return 'three_type'
  }
}

export const noticeModel = (model) => {
  switch (model) {
    case '1':
      return 'word_notice'
    case '2':
      return 'record_notice'
  }
}

/*转换成百分比 0.1000 => 10.00%*/
export const transferPer = (per)=>{
  if (!per || per === '0') return '0%'
  let float = Number(per)
  return (float * 100).toFixed(2) + '%'
}
/*呼叫详情状态*/
export const callDetailStatus = (type) => {
  if (!type) return
  if (type === '1'){
    return 'call_out'
  }else if (type === '2') {
    return 'call_answer'
  }else if (type === '8') {
    return 'call_hang'
  }else {
    return 'UnKnow'
  }
}

/*报警类型*/
export const alarmType = (type) => {
  if (!type) return
  if (type === '1'){
    return 'tamper_type'
  } else if (type === '2') {
    return 'oneKey_type'
  }
}

export const auto = (type) => {
  if (!type) return
  if (type === '0'){
    return 'trigger_three'
  } else if (type === '1') {
    return 'trigger_one'
  } else if (type === '2') {
    return 'trigger_two'
  }
}
export const hasChild = (item) => {
  return item.children && item.children.length !== 0
}

const showThisMenuEle = (item, access) => {
  if (item.meta && item.meta.access && item.meta.access.length) {
    if(hashOneOf(item.meta.access,access)) return true
    else  return false
  }else return true
}

/**
 * @param {Array} list 通过路由列表得到菜单列表
 * @returns {Array}
 */
export const getMenuByRouter = (list, access) => {
  let res = []
  forEach(list, item => {
    if (!item.meta || (item.meta && !item.meta.hideInMenu)) {
      let obj = {
        icon: (item.meta && item.meta.icon) || '',
        name: item.name,
        meta: item.meta
      }
      if ((hasChild(item) || (item.meta && item.meta.showAlways)) && showThisMenuEle(item, access)) {
        obj.children = getMenuByRouter(item.children, access)
      }
      if (item.meta && item.meta.href) obj.href = item.meta.href
      if (showThisMenuEle(item, access)) res.push(obj)
    }
  })
  return res
}

/**
 * @param {Array} routeMetched 当前路由metched
 * @returns {Array}
 */
export const getBreadCrumbList = (route, homeRoute) => {
  let homeItem = { ...homeRoute, icon: homeRoute.meta.icon }
  let routeMetched = route.matched
  if (routeMetched.some(item => item.name === homeRoute.name)) return [homeItem]
  let res = routeMetched.filter(item => {
    return item.meta === undefined || !item.meta.hideInBread
  }).map(item => {
    let meta = { ...item.meta }
    if (meta.title && typeof meta.title === 'function') {
      meta.__titleIsFunction__ = true
      meta.title = meta.title(route)
    }
    let obj = {
      icon: (item.meta && item.meta.icon) || '',
      name: item.name,
      meta: meta
    }
    return obj
  })
  res = res.filter(item => {
    return !item.meta.hideInMenu
  })
  return [{ ...homeItem, to: homeRoute.path }, ...res]
}

export const getRouteTitleHandled = (route) => {
  let router = { ...route }
  let meta = { ...route.meta }
  let title = ''
  if (meta.title) {
    if (typeof meta.title === 'function') {
      meta.__titleIsFunction__ = true
      title = meta.title(router)
    } else title = meta.title
  }
  meta.title = title
  router.meta = meta
  return router
}

export const showTitle = (item, vm) => {
  let { title, __titleIsFunction__ } = item.meta
  if (!title) return
  if (useI18n) {
    if (title.includes('{{') && title.includes('}}') && useI18n) title = title.replace(/({{[\s\S]+?}})/, (m, str) => str.replace(/{{([\s\S]*)}}/, (m, _) => vm.$t(_.trim())))
    else if (__titleIsFunction__) title = item.meta.title
    else title = vm.$t(item.name)
  } else title = (item.meta && item.meta.title) || item.name
  return title
}

/**
 * @description 本地存储和获取标签导航列表
 */
export const setTagNavListInLocalstorage = list => {
  localStorage.tagNaveList = JSON.stringify(list)
}
/**
 * @returns {Array} 其中的每个元素只包含路由原信息中的name, path, meta三项
 */
export const getTagNavListFromLocalstorage = () => {
  const list = localStorage.tagNaveList
  return list ? JSON.parse(list) : []
}

/**
 * @param {Array} routers 路由列表数组
 * @description 用于找到路由列表中name为home的对象
 */
export const getHomeRoute = (routers, homeName = 'home') => {
  let i = -1
  let len = routers.length
  let homeRoute = {}
  while (++i < len) {
    let item = routers[i]
    if (item.children && item.children.length) {
      let res = getHomeRoute(item.children, homeName)
      if (res.name) return res
    } else {
      if (item.name === homeName) homeRoute = item
    }
  }
  return homeRoute
}

/**
 * @param {*} list 现有标签导航列表
 * @param {*} newRoute 新添加的路由原信息对象
 * @description 如果该newRoute已经存在则不再添加
 */
export const getNewTagList = (list, newRoute) => {
  const { name, path, meta } = newRoute
  let newList = [...list]
  if (newList.findIndex(item => item.name === name) >= 0) return newList
  else newList.push({ name, path, meta })
  return newList
}

/**
 * @param {*} access 用户权限数组，如 ['super_admin', 'admin']
 * @param {*} route 路由列表
 */
const hasAccess = (access, route) => {
  if (route.meta && route.meta.access) return hasOneOf(access, route.meta.access)
  else return true
}

/**
 * 权鉴
 * @param {*} name 即将跳转的路由name
 * @param {*} access 用户权限数组
 * @param {*} routes 路由列表
 * @description 用户是否可跳转到该页
 */
export const canTurnTo = (name, access, routes) => {
  const routePermissionJudge = (list) => {
    return list.some(item => {
      if (item.children && item.children.length) {
        return routePermissionJudge(item.children)
      } else if (item.name === name) {
        return hasAccess(access, item)
      }
    })
  }

  return routePermissionJudge(routes)
}

/**
 * @param {String} url
 * @description 从URL中解析参数
 */
export const getParams = url => {
  const keyValueArr = url.split('?')[1].split('&')
  let paramObj = {}
  keyValueArr.forEach(item => {
    const keyValue = item.split('=')
    paramObj[keyValue[0]] = keyValue[1]
  })
  return paramObj
}

/**
 * @param {Array} list 标签列表
 * @param {String} name 当前关闭的标签的name
 */
export const getNextRoute = (list, route) => {
  let res = {}
  if (list.length === 2) {
    res = getHomeRoute(list)
  } else {
    const index = list.findIndex(item => routeEqual(item, route))
    if (index === list.length - 1) res = list[list.length - 2]
    else res = list[index + 1]
  }
  return res
}

/**
 * @param {Number} times 回调函数需要执行的次数
 * @param {Function} callback 回调函数
 */
export const doCustomTimes = (times, callback) => {
  let i = -1
  while (++i < times) {
    callback(i)
  }
}

/**
 * @param {Object} file 从上传组件得到的文件对象
 * @returns {Promise} resolve参数是解析后的二维数组
 * @description 从Csv文件中解析出表格，解析成二维数组
 */
export const getArrayFromFile = (file) => {
  let nameSplit = file.name.split('.')
  let format = nameSplit[nameSplit.length - 1]
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.readAsText(file) // 以文本格式读取
    let arr = []
    reader.onload = function (evt) {
      let data = evt.target.result // 读到的数据
      let pasteData = data.trim()
      arr = pasteData.split((/[\n\u0085\u2028\u2029]|\r\n?/g)).map(row => {
        return row.split('\t')
      }).map(item => {
        return item[0].split(',')
      })
      if (format === 'csv') resolve(arr)
      else reject(new Error('[Format Error]:你上传的不是Csv文件'))
    }
  })
}

/**
 * @param {Array} array 表格数据二维数组
 * @returns {Object} { columns, tableData }
 * @description 从二维数组中获取表头和表格数据，将第一行作为表头，用于在iView的表格中展示数据
 */
export const getTableDataFromArray = (array) => {
  let columns = []
  let tableData = []
  if (array.length > 1) {
    let titles = array.shift()
    columns = titles.map(item => {
      return {
        title: item,
        key: item
      }
    })
    tableData = array.map(item => {
      let res = {}
      item.forEach((col, i) => {
        res[titles[i]] = col
      })
      return res
    })
  }
  return {
    columns,
    tableData
  }
}

export const findNodeUpper = (ele, tag) => {
  if (ele.parentNode) {
    if (ele.parentNode.tagName === tag.toUpperCase()) {
      return ele.parentNode
    } else {
      return findNodeUpper(ele.parentNode, tag)
    }
  }
}

export const findNodeUpperByClasses = (ele, classes) => {
  let parentNode = ele.parentNode
  if (parentNode) {
    let classList = parentNode.classList
    if (classList && classes.every(className => classList.contains(className))) {
      return parentNode
    } else {
      return findNodeUpperByClasses(parentNode, classes)
    }
  }
}

export const findNodeDownward = (ele, tag) => {
  const tagName = tag.toUpperCase()
  if (ele.childNodes.length) {
    let i = -1
    let len = ele.childNodes.length
    while (++i < len) {
      let child = ele.childNodes[i]
      if (child.tagName === tagName) return child
      else return findNodeDownward(child, tag)
    }
  }
}

export const showByAccess = (access, canViewAccess) => {
  return hasOneOf(canViewAccess, access)
}

/**
 * @description 根据name/params/query判断两个路由对象是否相等
 * @param {*} route1 路由对象
 * @param {*} route2 路由对象
 */
export const routeEqual = (route1, route2) => {
  const params1 = route1.params || {}
  const params2 = route2.params || {}
  const query1 = route1.query || {}
  const query2 = route2.query || {}
  return (route1.name === route2.name) && objEqual(params1, params2) && objEqual(query1, query2)
}

/**
 * 判断打开的标签列表里是否已存在这个新添加的路由对象
 */
export const routeHasExist = (tagNavList, routeItem) => {
  let len = tagNavList.length
  let res = false
  doCustomTimes(len, (index) => {
    if (routeEqual(tagNavList[index], routeItem)) res = true
  })
  return res
}

export const localSave = (key, value) => {
  localStorage.setItem(key, value)
}

export const localRead = (key) => {
  return localStorage.getItem(key) || ''
}

// scrollTop animation
export const scrollTop = (el, from = 0, to, duration = 500, endCallback) => {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000 / 60)
      }
    )
  }
  const difference = Math.abs(from - to)
  const step = Math.ceil(difference / duration * 50)

  const scroll = (start, end, step) => {
    if (start === end) {
      endCallback && endCallback()
      return
    }

    let d = (start + step > end) ? end : start + step
    if (start > end) {
      d = (start - step < end) ? end : start - step
    }

    if (el === window) {
      window.scrollTo(d, d)
    } else {
      el.scrollTop = d
    }
    window.requestAnimationFrame(() => scroll(d, end, step))
  }
  scroll(from, to, step)
}

/**
 * @description 根据当前跳转的路由设置显示在浏览器标签的title
 * @param {Object} routeItem 路由对象
 * @param {Object} vm Vue实例
 */
export const setTitle = (routeItem, vm) => {
  const handledRoute = getRouteTitleHandled(routeItem)
  const pageTitle = showTitle(handledRoute, vm)
  const resTitle = pageTitle ? `${title} - ${pageTitle}` : title
  window.document.title = resTitle
}


//会议左侧列表
export const generConf=(conferences)=>{
  if (!Array.isArray(conferences)) return;
  let arr = []

  let _inline = 0
  let _offline = 0
  let _arr = uniqueArray(conferences,'confname')

  forEach(_arr,item=>{
    let confno = item.confno;
    let confname = item.confname;
    let tmp =false;
    if(confno==undefined)
    {

      confno=confname;

    }
    if(item.confname.indexOf("meeting")>-1)
    {
      tmp=true;
    }
    let area = {'confno':confno,'confname':confname,'tmp':tmp,'membernum':0};
    arr.push(area);
  });
  forEach(conferences,item=>{
    let deptid = item.confname
    let status = item.status
    forEach(arr,it=>{
      let _deptid = it.confname
      if (deptid === _deptid){

        it.membernum += 1
      }
    })

  });
  return arr;
}

export const generConfList = (ConfList, conferences) => {
  let arr = []
  let _arr = uniqueArray(ConfList, 'confno');
  if(_arr!=null){
    forEach(_arr, item => {
      let confno = item.confno;
      let confname = item.conf_name;
      let confnum = item.conf_num;
      let record = item.support_record;
      let tmp = false;
      if (confno == undefined) {
        confno = confname;
      }

      let area = {
        'confno': confno,
        'confname': confname,
        'tmp': tmp,
        'membernum': 0,
        'conf_num': confnum,
        'support_record': record
      };
      arr.push(area);
    });
  }

  if (conferences.length > 0) {
    let _arr2 = uniqueArray(conferences, 'confname');

    forEach(_arr2, item => {
      let confno = '';
      let confname = item.confname;
      let tmp = true;
      if (confno == '') {
        confno = confname;
      }
      if (confname && confname.indexOf("meeting") > -1) {
        tmp = true;
        let area = {'confno': confno, 'confname': confname, 'tmp': tmp, 'membernum': 0};
        arr.push(area);
      }

    });
  }

  forEach(conferences, item => {
    let deptid = item.confname
    forEach(arr, it => {
      let _deptid = it.confno;
      if (deptid == _deptid) {
        it.membernum += 1
      }
    })

  });
  return arr;
};


export const generConfList2 = (ConfList, conferences) => {

  let list=[];

  if(conferences.length > 0){

    forEach(conferences,item=>{
      if(list !=='' && list !=='[]' && list !== undefined){
       let confname = list.find(item2=> item2.confname == item.confname );
        if(confname ==='' || confname ==='[]' || confname ===undefined){
          list.push({confname:item.confname,num:0});
        }
      }else{
        list.push({confname:item.confname,num:0});
      }

    });

    forEach(list,item=>{
        let count=0;
      forEach(conferences,item2=>{

        if(item.confname == item2.confname){
          count++;
        }

      });
      item.num=count;
    });


  }

  generConfListArr(ConfList,list);

  return ConfList;
};

export const generConfListArr = (ConfList,list) => {
  forEach(ConfList,item=>{
    //console.log(item);
    if(item.isDept === '1'){    //分区
      item.membernum=0;
      //修改为打开的样式
      item.iconClass = 'el-icon-folder-opened'
      return generConfListArr(item.children,list);
    }else if(item.isDept === '0'){
      item.tmp=false;     //区分固定会议室和临时会议室
     // console.log(item);
                  //会议
      if(list !== '[]' && list !==undefined){
        forEach(list,item2=>{
          if(item2.confname === item.confno){
            item.membernum=item2.num;
            //console.log(item2.num);
          }
        });
        if(item.membernum === '' || item.membernum === undefined){
          item.membernum=0;
        }
      }else{
        item.membernum=0;
      }
    }
  });
  numberConfing(ConfList)
};

/**
 * 向上统计开会中的数量
 * @param list
 */
export const numberConfing = (list) => {
  forEach(list,item=>{
    if (item.isDept === '1') {
      let num = 0
      if (item.children && item.children.length > 0) {
        forEach(item.children, it => {
          num += it.membernum
          numberConfing(item)
        })
      }
      item.membernum = num
    }
  })
}



//
export const getDataByConfNO=(devices,fixedconferences,confno,conferences)=>{
  if (!Array.isArray(conferences)&&!Array.isArray(fixedconferences))
  {
    return;
  }
  let tmp=false;
  if(confno.indexOf("meeting")>-1)
  {
    tmp=true;
  }

  let arr = [];
  let have = [].concat(fixedconferences)
  forEach(fixedconferences,item=>{

    if (item.confno == confno){
      if (devices[item.exten] && !item.gradeCallee){
        arr.push(devices[item.exten]);
        let index = have.indexOf(item)
        if (index > -1) {
          have.splice(index,1)
        }
      }
      // forEach(devices,item2=>{
      //   if (item2.exten == item.exten && !item.gradeCallee){
      //     arr.push(item2);
      //     let index = have.indexOf(item)
      //     if (index > -1) {
      //       have.splice(index,1)
      //     }
      //   }
      // });
    }
  })
  forEach(have,item=>{
    let json = {}
    json.IsCanSpeak = item.IsCanSpeak
    json.cameraflag = '1'
    json.deptid = ''
    json.deptname = item.deptName
    json.employeename = item.employee_name
    json.exten = item.exten
    json.out = '1'
    json.order = item.status === 'Talking' ? "-3" : item.status === 'broading' ? "-2.5" : item.status === 'Ringing' ? "-2" : '1'
    json.status = item.status === 'Talking' || item.status === 'Ringing' ? item.status : 'UnKnow'
    json.gradeCallee = item.gradeCallee
    arr.push(json)
  })

  let arr2=[]

  forEach(conferences,item=>{
    if (item.confname == confno){
      let a = getInArrayExten(arr,item);
      if(a != null) {
        a.IsCanSpeak=item.IsCanSpeak;
        a.confname=item.confname;
        a.confno=item.confno;
        a.status=item.status ? item.status : a.status ? a.status : "UnKnow";
        a.gradeCallee = item.gradeCallee
        if(item.gradeCallee){
          a.status = item.status === 'Talking' || item.status === 'Ringing' ? item.status : 'UnKnow'
        }
        if(item.order){
          a.order= item.status === 'Talking' ? "-3" : item.status === 'Ringing' ? "-2" : item.status ==='Broading' ? '-2.5' : item.status === 'Idle' ? "-1" : item.status === 'UnKnow' ? "1" : '0';
        }
      } else{
        let dat = devices[item.exten];
        let e=null;
        if(dat  && (item.gradeCallee == dat.gradeCallee || (!item.gradeCallee && !dat.gradeCallee))){
          e = devices[item.exten];
        }
        if (e != null){
          e.IsCanSpeak=item.IsCanSpeak;
          e.confname=item.confname;
          e.confno=item.confno;
          e.status=item.status ? item.status : e.status ? e.status : "UnKnow";
          e.gradeCallee = item.gradeCallee
          if(item.gradeCallee){
            e.status = item.status === 'Talking' || item.status === 'Ringing' ? item.status : 'UnKnow'
          }
          if(item.order){
            e.order=item.status === 'Talking' ? "-3" : item.status === 'Ringing' ? "-2" : item.status ==='Broading' ? '-2.5' : item.status === 'Idle' ? "-1" : item.status === 'UnKnow' ? "1" : '0';
          }
          arr2.push(e);
        }
        else
        {
          let  ext=newConfExten(item.confname,item.exten,item.status,item.employee_name);
          ext.gradeCallee =item.gradeCallee ? item.gradeCallee : "";
          ext.deptname =item.deptName ? item.deptName : "";
          arr2.push(ext);
        }

      }
    }
  });

  /*
  forEach(arr,item=>{

    if (item.confno === confno){
      forEach(conferences,item2=>{
        if (item2.exten == item.exten){
          item.IsCanSpeak=item2.IsCanSpeak;
          item.confno=item2.confname;
        }
      });
    }
  });
  */

  if(arr2.length>0)
  {
    arr=[...arr,...arr2];
    //arr.push(arr2);
  }
  arr.sort(sortOrder);
  return arr;
}

/*会议室进入*/
export const ConferencesAdd = (confname, conferences, extens, exten, status,gradeCallee) => {
  //console.log("conflist",conflist);
  let checkexten = getInArrayExten2(conferences, exten,gradeCallee);
  if (!confname) {
    return null
  }
  if (checkexten != null) {
    if (checkexten.confname == confname){}
    return null;
  }
  let confs = [];
  var isIn = false;
  for (var i = 0; i < extens.length; i++) {
    extens[i].gradeCallee = extens[i].gradeCallee ? extens[i].gradeCallee : "";
    gradeCallee = gradeCallee ? gradeCallee : "";
    if (extens[i].exten === exten && extens[i].gradeCallee == gradeCallee) {
      extens[i].IsCanSpeak = true;
      extens[i].confname = confname;
      extens[i].confno = confname;
      // extens[i].status = status ? status : 'Talking'
      //conferences.push(extens[i]);
      confs = [...conferences, extens[i]]
      isIn = true;
      break;
    }
  }
  if (!isIn) {
    let ext = newConfExten(confname, exten,status);
    if(gradeCallee){
      ext.gradeCallee = gradeCallee;
    }
    // conferences.push(ext);
    confs = [...conferences, ext]
  }
  //console.log("会议室进入1",confs);
  return confs;


};
/*会议室离开*/
export const ConferencesDel=(conferences,exten,outLines,appKey)=>{
  //console.log("会议室离开0",conferences);
  appKey = appKey ? appKey : "";
  let index = conferences.findIndex(item=>item.exten===exten &&
    (appKey == item.gradeCallee || appKey == item.appKey || (!appKey && !item.appKey && !item.gradeCallee)))
  if (index>-1) {
    conferences.splice(index, 1);
    //删除邀请中的会议
    let cindex = outLines.findIndex(item=>item.extens.indexOf(exten)>-1)
    if (cindex > -1) {
      let json = outLines[cindex]
      let eindex = json.extens.findIndex(item=>item===exten)
      if (eindex > -1) {
        json.extens.splice(eindex,1)
        if (json.extens.length <= 0) {
          outLines.splice(cindex,1)
        }
      }
    }
  }
  return conferences
  //console.log("会议室离开",conferences);
}

export const getConferencesByExt=(nowconferences,conferences,exten)=>{
  let newItem = {};
  if (!Array.isArray(conferences))return newItem;
  forEach(conferences,item=>{
    if (item.exten === exten){
      newItem = item;
    }
  });
  forEach(nowconferences,item=>{
    if (item.exten === exten){
      newItem = item;
    }
  });
  return newItem;
}

/*会议室通话*/
export const conferencesTalking=(nowconferences,conferences,exten,status,appKey)=>{

  if (!Array.isArray(conferences))return;
  forEach(conferences,item=>{
    if (item.exten === exten && (item.appKey === appKey || item.gradeCallee === appKey)){
      item.status=status;
    }
  });
  forEach(nowconferences,item=>{
    if (item.exten === exten && (item.appKey === appKey || item.gradeCallee === appKey)){
      item.status=status;
    }
  });
  nowconferences.sort(sortOrder)
  conferences.sort(sortOrder)
}

/*会议室静音*/
export const ConferencesMute=(nowconferences,conferences,exten,appKey)=>{

  if (!Array.isArray(conferences))return;
  appKey = appKey ? appKey : "";
  forEach(conferences,item=>{
    item.gradeCallee = item.gradeCallee ? item.gradeCallee : item.appKey ? item.appKey : "";
    if (item.exten === exten && item.gradeCallee == appKey){
      item.IsCanSpeak=false;
    }
  });
  forEach(nowconferences,item=>{
    item.gradeCallee = item.gradeCallee ? item.gradeCallee : item.appKey ? item.appKey : "";
    if (item.exten === exten && item.gradeCallee == appKey){
      item.IsCanSpeak=false;
    }
  });
}

/*会议室静音*/
export const ConferencesUnMute=(nowconferences,conferences,exten,appKey)=>{

  if (!Array.isArray(conferences))return;
  appKey = appKey ? appKey : "";
  forEach(conferences,item=>{
    item.gradeCallee = item.gradeCallee ? item.gradeCallee : item.appKey ? item.appKey : "";
    if (item.exten === exten && item.gradeCallee == appKey){
      item.IsCanSpeak=true;
    }
  });
  forEach(nowconferences,item=>{
    item.gradeCallee = item.gradeCallee ? item.gradeCallee : item.appKey ? item.appKey : "";
    if (item.exten === exten && item.gradeCallee == appKey){
      item.IsCanSpeak=true;
    }
  });
}

/*会议室更新*/
export const NowConferencesUpdate=(nowconferences,conferences)=>{
  //console.log("conferences:",conferences);
  forEach(conferences,item=>{
    if (item.confname == confno){
      let a=getInArrayExten(arr,item);
      if(getInArrayExten(arr,item)!=null)
      {
        //console.log("item.exten:",item.exten);
      }
      else{
        //console.log("111item.exten:",item.exten);
        let e=getInArrayExten(devices,item);
        if (e!=null){
          //console.log("item.confname tmp:::",item.confname);
          e.IsCanSpeak=item.IsCanSpeak;
          e.confname=item.confname;
          e.confno=item.confno;
          //console.log("222item.exten:",item.exten);
          arr2.push(e);
        }
        else
        {
          //console.log("3333item.exten:",item.exten);
          let  ext=newConfExten(item.confname,item.exten);
          arr2.push(ext);
        }

      }
    }
  });
}

export function getConfMemberNum(conferences,confname)
{
  if(confname=='')return;
  let num=0;
//console.log("conferences conferences",conferences);
  forEach(conferences,item=>{
    if(item.confname==confname)
    {
      num++;
    }
  });
//  console.log("num:",num,"confname:",confname);
  return num;
}

export const countConflist=(data,caller)=>{
  data.forEach(temp=>{
      if(temp.isDept ==='1'){
        countConflist(temp.children);
      }else if(temp.isDept === '0'){
        if(caller == temp.confno){
          return temp.confname;
        }
      }
  })

}


/*生成会议呼叫信息*/
export const generConfInfo=(data,conflist,callConfList)=>{
  if (!data) return;
  //console.log("callConfList",callConfList);
  let callee = data.ExtenInfo.split('@')[0]
  let caller = data.confname;
  if(!caller.indexOf("meeting")>-1)
  {
    for(let i = 0; i < conflist.length; i++){
      if(caller == conflist[i].confno){
        caller= conflist[i].confname;
        break;
      }
    }
    if(caller=='null')
    {
      for(let i = 0; i < callConfList.length; i++){
        if(callee == callConfList[i].callee){

          caller= callConfList[i].caller;
          break;
        }
      }
    }
    if(caller=='null')
    {
      //console.log(" generConfInfo caller==null string",callConfList);
      return null;
    }

  }

  let type = data.method
  if(callee === caller)return
  let date = getFormatDate("HH:MM:SS", new Date())
  let json = {"callee":callee,'caller':caller,'type':type,'date':date}
  return json
}

export function getInArrayExten(arr,value){

  for(let i = 0; i < arr.length; i++){
    if(value.exten == arr[i].exten && (value.gradeCallee == arr[i].gradeCallee || (!value.gradeCallee && !arr[i].gradeCallee))){
      return arr[i];
    }
  }
  return null;
}

export function getInArrayExten2(arr,value,gradeCallee){

  for(let i = 0; i < arr.length; i++){
    if(value === arr[i].exten && (arr[i].gradeCallee == gradeCallee || (!arr[i].gradeCallee && !gradeCallee))){
      return arr[i];
    }
  }
  return null;
}

function newConfExten(confname,exten,status,employeename)
{
  let ext = {};//{exten:12,status:offline,out:0,deptid:1,deptname:c,cameraflag:0,employeename:12,employeeid:1,position:xxx,order:1}
  ext.confname=confname;
  ext.confno=confname;
  ext.exten=exten;
  ext.status = status ? status : 'Talking'
  ext.employeename = employeename ? employeename : exten

  ext.IsCanSpeak=true;
  ext.order=-3;

  return ext;

}


// 循环出父节点
export function transferZtree2standardData(data,id,pId,name) {
  // 建立个树形结构,需要定义个最顶层的父节点，pId是0
  let parent = [];
  for (let i = 0; i < data.length; i++) {

    if(data[i][pId] !== -1){
    }else{
      let obj = {
        label: data[i][name],
        id: data[i][id],
        children: []
      };
      parent.push(obj);//数组加数组值
    }
    // console.log(obj);
    //  console.log(parent,"bnm");

  }
  children(parent);

  // 调用子节点方法,参数为父节点的数组
  function children(parent) {
    console.log(parent)
    if (data.length !== 0) {
      for (let i = 0; i < parent.length; i++) {
        for (let j = 0; j < data.length; j++) {
          if (parent[i].id == data[j][pId]){
            let obj = {
              label: data[j][name],
              id: data[j][id],
              children: []
            };
            parent[i].children.push(obj);
          }
        }
        children(parent[i].children);
      }
    }
  }
  console.log(parent,"bjil")
  return parent;
}


export const getConfNameByTempMember = (confs,tempConf,exten)=>{
  if (!Array.isArray(tempConf) || tempConf.length <= 0) {
    return null
  }
  //获取所有存在的该会议室的会议名
  let hasNames = []
  for (let i = 0; i < confs.length; i++) {
    let cons = confs[i]
    if (cons.exten === exten) {
      hasNames.push(cons.confname)
    }
  }
  for (let i = 0; i < tempConf.length; i++) {
    let confjson = tempConf[i]
    let extens = confjson.extens
    if (extens.indexOf(exten) > -1) {
      if (hasNames.indexOf(confjson.confname) < 0) {
        return confjson.confname
      }
    }
  }
  return null
}

/**
 * 移除其余会议室中的分机
 * @param confname
 * @param confs
 * @param outs
 * @param exten
 */
export const removeOtherExten = (confname,confs,outs,exten,appKey) => {
  appKey = appKey ? appKey : "";
  if (Array.isArray(confs)) {
    let indexs = []
    for (let i = 0; i < confs.length; i++) {
      let conf = confs[i]
      conf.appKey = conf.appKey ? conf.appKey : conf.gradeCallee ? conf.gradeCallee : "";
      if (conf.exten === exten && conf.confname !== confname && conf.appKey === appKey) {
        indexs.push(i)
      }
    }
    for (let i = 0; i < indexs.length; i++) {
      confs.splice(indexs[i],1)
    }
  }

  if (Array.isArray(outs)) {
    let oindexs = []
    for (let i = 0; i < outs.length; i++) {
      let out = outs[i]
      let index = out.extens.findIndex(item => item === exten)
      if (index > -1) {
        if (out.confname !== confname) {
          out.extens.splice(index,1)
          if (out.extens.length <= 0) {
            oindexs.push(i)
          }
        }
      }
    }
    for (let i = 0; i < oindexs.length; i++) {
      out.splice(oindexs[i],1)
    }
  }
}

 /**
  * 使用循环的方式判断一个元素是否存在于一个数组中
 * @param {Object} arr 数组
  * @param {Object} value 元素值
  */
 export function isInArray(arr,value){
     for(var i = 0; i < arr.length; i++){
         if(value == arr[i]){
            return true;
         }
     }
     return false;
 }

//根据modalId 返回图标
export const extenIcon = (type) => {
  let iconClass = 'other'
  switch (type) {
    case '-1':
      iconClass = 'app_svg'
      break
    case '1':
      iconClass = 'mobile'
      break
    case '2':
      iconClass = 'speak'
      break
    case '3':
      iconClass = 'broad'
      break
    case '4':
      iconClass = 'door'
      break
    case '5':
      iconClass = 'pc'
      break
    case '6':
      iconClass = 'car'
      break
    case '7':
      iconClass = 'voice'
      break
    case '8':
      iconClass = 'view'
      break
    case '9':
      iconClass = 'other'
      break
    default:
      iconClass = 'other'
      break
  }
  return iconClass
}

// 定义粘贴函数
export const onPaste = (event) => {
  // 剪贴板没数据，则直接返回
  if (!event.clipboardData || !event.clipboardData.items) {
    return;
  }
  // 封装Promise
  return new Promise(async (resovle, reject) => {
    for(let i = 0, len = event.clipboardData.items.length; i < len; i++) {
      const item = event.clipboardData.items[i];
      const type = item.type;
      if (item.kind === 'string') {
        let reg = /<\/?.+?\/?>/g; // 匹配粘贴文本中的html标签
        item.getAsString(str => {
          let reg2 = /^<html xmlns/g;
          if(type.match('/html$')&&!(reg2.test(str))){
            resovle({
              data: str.replace(reg, '').replace(/(\r\n)|(\n)/g, '') // 去掉换行符
            })
          }
        })
      } else if (item.kind === 'file') {
        const file = item.getAsFile();
        if (item.type.match('^image/')) {
          // 处理图片
          handleImage(file,  (data) => {
            resovle(data)
          })
        } else {
          // 其他文件直接返回
          arr.push({
            data: file,
            type: 'file'
          })
        }
      } else {
        reject(new Error('不支持粘贴该类型'));
      }
    }
  })
}

/**
 * 图片处理
 * @param {*} file 图片
 * @param {*} callback 回调
 * @param {*} maxWidth
 * @returns
 */
function handleImage(file, callback, maxWidth = 200) {
  if (!file || !/\/(?:png|jpg|jpeg|gif)/i.test(file.type)) {
    console.log('图片格式不支持');
    return;
  }
  const reader = new FileReader();
  reader.onload = function () {
    const result = this.result;
    let img = new Image();
    img.onload = function() {
      let compressedDataUrl = compress(img, file.type, maxWidth, true);
      let url = compress(img, file.type, maxWidth, false);
      img = null;
      callback({
        data: file,
        compressedDataUrl,
        url,
        type: 'image'
      })
    }
    img.src = result;
  };
  reader.readAsDataURL(file);
}

/**
 * 图片压缩
 * @param {*} img 图片对象
 * @param {*} type 图片类型
 * @param {*} maxWidth 图片最大宽度
 * @param {*} flag
 */
function compress(img, type, maxWidth, flag) {
  let canvas = document.createElement('canvas');
  let ctx2 = canvas.getContext('2d');

  let ratio = img.width / img.height;
  let width = img.width, height = img.height;
  // 根据flag判断是否压缩图片
  if (flag) {
    // 压缩后的图片展示在输入框
    width  = maxWidth;
    height = maxWidth / ratio; // 维持图片宽高比
  }
  canvas.width = width;
  canvas.height = height;

  ctx2.fillStyle = '#fff';
  ctx2.fillRect(0, 0, canvas.width, canvas.height);
  ctx2.drawImage(img, 0, 0, width, height);

  let base64Data = canvas.toDataURL(type, 0.75);

  if (type === 'image/gif') {
    // let regx = /(?<=data:image).*?(?=;base64)/; // 正则表示时在用于replace时，根据浏览器的不同，有的需要为字符串，这种在构建时会报错
    let regx = /data:image.*?;base64/g; // 正则表示时在用于replace时，根据浏览器的不同，有的需要为字符串
    base64Data = base64Data.replace(regx, '/gif');
  }
  canvas = null;
  ctx2 = null;
  return base64Data;
}



// WEBPACK FOOTER //
// ./src/libs/util.js